import { ArticleStatus, IArticle, IProductGroup, IQuantityPerUnit, PackagingUnitType } from '@alberta/konexi-shared';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { removeNullsFromArrays } from '@common/filter/array-null-filter';
import { ArticleDB, ProductGroupDB } from '@common/repository/databases';
import { QueryService } from '@services/query/query.service';
import { InfoBoxType } from 'src/app/shared/components/common/info-box/info-box.component';
import { InstitutionAttributeConfigService } from 'src/app/shared/services/tenant-config/institution-attribute-config.service';
import { v4 } from 'uuid';
export interface SwodocArticle extends IArticle {
  articleId: string;
  packagingUnit: IQuantityPerUnit;
  quantity: number;
  productGroupName: string;
  annotation?: string;
  unit?: string;
}
@Component({
  selector: 'swodoc-node-add-article-element',
  templateUrl: 'swodoc-node-add-article-element.html',
  styleUrls: ['swodoc-node-add-article-element.scss'],
  providers: [InstitutionAttributeConfigService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeAddArticleElement {
  @ViewChild('autocomplete') autocomplete: any;
  @Input() node: any;

  get TemplateNodeTitle() {
    return this.node?.title as string;
  }

  get articles(): SwodocArticle[] {
    return this.node?.responses[0]?.value;
  }

  set articles(value: SwodocArticle[]) {
    this.node.responses[0].value = value;
  }

  InfoBoxType = InfoBoxType;
  restriction = article => article.status != ArticleStatus.Available;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _queryService: QueryService
  ) {}

  public async articleAdded(articleId: string) {
    const articleFromDb = await this._queryService.get<IArticle>(articleId, ArticleDB);
    const addedArticle = removeNullsFromArrays(articleFromDb) as SwodocArticle;
    addedArticle.articleId = addedArticle._id;
    addedArticle._id = v4();

    // set packaging unit and quantity
    const nonArchivedPackagingUnits = addedArticle.packagingUnits.filter(packagingUnit => !packagingUnit.archived);
    const packagingUnitWithQuantityOneAndUnitStk = nonArchivedPackagingUnits.find(
      packagingUnit => packagingUnit.quantity === 1 && packagingUnit.unit === PackagingUnitType.piece
    );
    const defaultPackagingUnit = nonArchivedPackagingUnits.find((item: any) => item.defaultPackagingUnit);
    /**
     * if we only have one packaging unit - take it
     * otherwise take the default packaging unit
     * orherwise take the packaging unit with quantity=1 and unit=stk
     * otherwise take the first one
     */
    if (nonArchivedPackagingUnits.length) {
      const packagingUnit =
        nonArchivedPackagingUnits.length === 1
          ? nonArchivedPackagingUnits[0]
          : defaultPackagingUnit || packagingUnitWithQuantityOneAndUnitStk || nonArchivedPackagingUnits[0];
      addedArticle.packagingUnit = packagingUnit;
    }
    addedArticle.quantity = 1;

    if (this.node.responses.length === 0) {
      this.node.responses.push({ value: [] });
    }
    if (this.articles.length === 0) {
      this.articles = [];
    }

    const productGroup = await this._queryService.get<IProductGroup>(articleFromDb.productGroupId, ProductGroupDB);
    if (productGroup) {
      addedArticle.productGroupName = productGroup.name;
    }

    this.articles.push(addedArticle);
    this._changeDetectorRef.markForCheck();
  }

  public handleRemove(articleId: string) {
    this.articles = this.articles.filter((item: IArticle) => item._id !== articleId);
    this._changeDetectorRef.markForCheck();
  }
  public handleAnnotationChange(annotation: string, articleId: string) {
    const changedArticle = this.articles.find((item: IArticle) => item._id === articleId);
    if (changedArticle) {
      changedArticle.annotation = annotation;
      this._changeDetectorRef.markForCheck();
    }
  }
}
